import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import GroupCreateModal from './GroupCreateModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  storage: state.storage,
  status: state.modal.groupCreateModal
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_GROUP_CREATE, false),
  createGroup: actions.group.createGroup
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/GroupCreateModal/index.js